interface ColorPickerProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
}

export const ColorPicker = ({ label, value, onChange, placeholder }: ColorPickerProps) => {
    return (
        <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
            <div className="flex items-center gap-2">
                <input
                    type="color"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    className="h-9 w-12 border rounded cursor-pointer"
                />
                <input
                    type="text"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    className="flex-1 border rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                    placeholder={placeholder}
                />
            </div>
        </div>
    );
};
